import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect, type ReactNode } from "react";

import { useToastUserFacingError } from "@/components/errors/toast-user-facing-error";
import {
  createQueryClient,
  getAppQueryClient,
  setAppMutationErrorToastHandler,
} from "@/lib/query/app-query-client";

/** 挂载全局 Mutation 失败 Toast，并向下提供应用级 QueryClient。 */
export function GlobalRequestErrorListener({
  children,
}: {
  children: ReactNode;
}) {
  const toastUserFacingError = useToastUserFacingError();

  useEffect(() => {
    setAppMutationErrorToastHandler(toastUserFacingError);
  }, [toastUserFacingError]);

  return (
    <QueryClientProvider client={getAppQueryClient()}>
      {children}
    </QueryClientProvider>
  );
}

export { createQueryClient };
